import { fetcher, useAuthFetch } from "matsuri-hooks"
import { Listing } from "../domain/listing"
import { PropertyDetail, PropertySummaryWithCount } from "../domain/property"
import { RoomTypeCalendar } from "../domain/calendar"
import { m2mCore } from "../endpoints/m2m-core"
import { m2mCore_v1 } from "../endpoints/m2m-core.v1"

export const usePropertySummaries = (token: string) => {
    return useAuthFetch<{ data: PropertySummaryWithCount[] }>(
        token,
        m2mCore.v1.propertyList(),
        {}
    )
}

export const usePropertyDetail = (
    token: string,
    propertyId: string | undefined
) => {
    return useAuthFetch<PropertyDetail>(
        token,
        propertyId ? m2mCore.v1.propertyGet({ id: propertyId }) : null,
        {}
    )
}

export const requestGetPropertyDetail = (token: string, propertyId: string) => {
    return fetcher<PropertyDetail>(m2mCore.v1.propertyGet({ id: propertyId }), {
        token
    })
}

export interface CreatePropertyResponse {
    propertyId: string
}

export const requestCreateProperty = (
    token: string,
    input: {
        name: string
        address?: {
            prefectureId: string
            cityId: string
            rest: string
        }
        prefecture?: string
        city?: string
        street?: string
    }
) => {
    return fetcher<CreatePropertyResponse>(m2mCore_v1.propertyCreate(), {
        token,
        method: m2mCore_v1.propertyCreate.method,
        body: JSON.stringify(input)
    })
}

export const requestUpdateProperty = (
    token: string,
    propertyId: string,
    input: {
        name: string
        tags: Record<string, string>
    }
) => {
    return fetcher(m2mCore_v1.propertyEdit({ id: propertyId }), {
        token,
        method: "PUT",
        body: JSON.stringify(input)
    })
}

export const usePropertySingleRoomTypeCalendar = (
    token: string,
    propertyId: string,
    startDate: string,
    endDate: string
) => {
    return useAuthFetch<{
        items: RoomTypeCalendar
        listings: Listing[]
    }>(
        token,
        m2mCore_v1.getPropertyCalendarItemsOnlySingleRoomTypesById({
            propertyId,
            startDate,
            endDate,
            isOnlyActive: "true"
        }),
        {}
    )
}
